import React from "react";
import Link from "gatsby-link";
import ReactSwipe from "react-swipe";
import ClassNames from "classnames";
import Item from "./testimonial-item";

let tweetRe = /(^|[^'"])(https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+))/;

class Testimonials extends React.Component {
  constructor(props) {
    super(props);

    let perPage = 3;
    if (this.props.tablet) {
      perPage = 2;
    }

    this.state = {
      nPage: 0,
      perPage: perPage,
      totalPages: Math.ceil(props.data.length / 3)
    };
  }

  showPage(n) {
    if (n < 0) {
      n = this.state.totalPages - 1;
    }
    if (n >= this.state.totalPages) {
      n = 0;
    }
    this.setState({
      nPage: n
    });
  }

  render() {
    let testimonials = this.props.data;

    let n = this.state.nPage * this.state.perPage;
    let visibleTestis = testimonials.slice(n, n + this.state.perPage);

    let pages = [];
    for (var i = 0; i < this.state.totalPages; i++) {
      pages.push(i);
    }

    return (
      <div
        className={ClassNames({
          Testimonials: true,
          desktop: !this.props.tablet,
          tablet: this.props.tablet
        })}
      >
        <div className="internal">
          <h2>What people are saying</h2>
          <div className="items">
            {visibleTestis.map((item, i) => {
              return <Item data={item} key={i} />;
            })}
          </div>
        </div>
        <button
          className="arrow left"
          onClick={() => {
            this.showPage(this.state.nPage - 1);
          }}
        >
          <svg
            width="25"
            height="19"
            viewBox="0 0 25 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.0977871 8.92747C0.0325977 9.04683 3.55222e-06 9.19601 3.53553e-06 9.37504C3.51883e-06 9.55407 0.0325976 9.74304 0.097787 9.94196C0.162976 10.0016 0.211868 10.0613 0.244462 10.121C0.277057 10.1807 0.325948 10.2503 0.391138 10.3299L8.73533 17.9684C9.01782 18.2071 9.34376 18.3264 9.71317 18.3264C10.0826 18.3264 10.4085 18.2071 10.691 17.9684C10.9518 17.7098 11.0821 17.4114 11.0821 17.0732C11.0821 16.7351 10.9518 16.4367 10.691 16.1781L4.69361 10.6879L23.5984 10.6879C24.033 10.6879 24.3753 10.5735 24.6252 10.3448C24.8751 10.116 25 9.81267 25 9.43472C25 9.03688 24.8751 8.72358 24.6252 8.49483C24.3753 8.26607 24.033 8.15169 23.5984 8.15169L4.69361 8.15169L10.691 2.69135C10.9518 2.43275 11.0821 2.13438 11.0821 1.79621C11.0821 1.45805 10.9518 1.15967 10.691 0.901076C10.5389 0.761832 10.3705 0.662374 10.1858 0.602697C10.0011 0.543021 9.84355 0.513184 9.71317 0.513184C9.56106 0.513184 9.39266 0.543021 9.20796 0.602697C9.02325 0.662373 8.86571 0.761832 8.73534 0.901076L0.391138 8.53958C0.325948 8.59926 0.26076 8.65893 0.195571 8.71861C0.130381 8.77828 0.0977871 8.8479 0.0977871 8.92747Z"
              fill="#7B6756"
            />
          </svg>
        </button>
        <button
          className="arrow right"
          onClick={() => {
            this.showPage(this.state.nPage + 1);
          }}
        >
          <svg
            width="25"
            height="19"
            viewBox="0 0 25 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.9022 9.91188C24.9674 9.79253 25 9.64334 25 9.46431C25 9.28528 24.9674 9.09631 24.9022 8.89739C24.837 8.83772 24.7881 8.77804 24.7555 8.71836C24.7229 8.65869 24.6741 8.58907 24.6089 8.5095L16.2647 0.870994C15.9822 0.63229 15.6562 0.512939 15.2868 0.512939C14.9174 0.512939 14.5915 0.63229 14.309 0.870994C14.0482 1.12959 13.9179 1.42797 13.9179 1.76613C13.9179 2.1043 14.0482 2.40267 14.309 2.66127L20.3064 8.15144H1.40156C0.966969 8.15144 0.62473 8.26582 0.374837 8.49458C0.124944 8.72334 0 9.02669 0 9.40464C0 9.80248 0.124944 10.1158 0.374837 10.3445C0.62473 10.5733 0.966969 10.6877 1.40156 10.6877H20.3064L14.309 16.148C14.0482 16.4066 13.9179 16.705 13.9179 17.0431C13.9179 17.3813 14.0482 17.6797 14.309 17.9383C14.4611 18.0775 14.6295 18.177 14.8142 18.2367C14.9989 18.2963 15.1565 18.3262 15.2868 18.3262C15.4389 18.3262 15.6073 18.2963 15.792 18.2367C15.9768 18.177 16.1343 18.0775 16.2647 17.9383L24.6089 10.2998C24.6741 10.2401 24.7392 10.1804 24.8044 10.1207C24.8696 10.0611 24.9022 9.99145 24.9022 9.91188Z"
              fill="#7B6756"
            />
          </svg>
        </button>
        <div className="dots">
          {pages.map((page, i) => {
            return (
              <div
                className={ClassNames({
                  dot: true,
                  "is-active": i === this.state.nPage
                })}
                key={i}
                onClick={() => {
                  this.showPage(i);
                }}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/home/testimonials-desktop.js